import { makeStyles } from '@material-ui/core';
import { useHotkeysCode, useWithSound } from '@timeflies/app-ui';
import { TimeGauge } from '@timeflies/time-gauge-panel';
import React from 'react';
import { SpellButtonSimple } from './spell-button-simple';
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: function (_a) {
            var disabled = _a.disabled;
            return ({
                display: 'flex',
                flexDirection: 'column',
                opacity: disabled ? 0.5 : 1,
            });
        },
        timeGauge: {
            padding: 2,
            backgroundColor: palette.background.default
        }
    });
});
var hotkeysCodes = ['Digit1', 'Digit2', 'Digit3', 'Digit4'];
var noop = function () { };
export var SpellButton = function (_a) {
    var spellRole = _a.spellRole, index = _a.index, duration = _a.duration, imageSize = _a.imageSize, selected = _a.selected, disabled = _a.disabled, _b = _a.onClick, onClick = _b === void 0 ? noop : _b, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    var classes = useStyles({ disabled: disabled });
    var withSound = useWithSound('buttonClick');
    useHotkeysCode(hotkeysCodes[index], withSound(onClick));
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.timeGauge },
            React.createElement(TimeGauge, { duration: duration })),
        React.createElement(SpellButtonSimple, { onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, disabled: disabled, imageSize: imageSize, spellRole: spellRole, selected: selected, padding: 4 })));
};
